import { useQuery } from 'react-query';
import {
	getCommissionableProducts,
	getOrderReturns,
	getReturnProducts,
} from '@/services/orderReturns';
import type { FilterType } from '@/types/table';

export const useGetOrderReturns = ({
	page = 1,
	limit = 15,
	enabled = true,
	columnsFilters = '[]',
	search = '',
	status = '',
	globalFilters = '[]',
	sort = '',
}: FilterType) => {
	return useQuery({
		queryKey: [
			'orderReturns',
			page,
			limit,
			columnsFilters,
			search,
			status,
			globalFilters,
			sort,
		],
		queryFn: () =>
			getOrderReturns(
				page,
				limit,
				columnsFilters,
				search,
				status as string | number,
				globalFilters as string,
				sort as string,
			),
		enabled,
		keepPreviousData: false,
	});
};

export const useGetReturnProducts = ({
	page = 1,
	limit = 15,
	enabled = true,
	globalFilters = '[]',
}: FilterType) => {
	return useQuery({
		queryKey: ['orderReturns', page, limit, globalFilters],
		queryFn: () => getReturnProducts(page, limit, globalFilters as string),
		enabled,
		keepPreviousData: false,
	});
};

export const useGetCommissionableProducts = (enabled = true) => {
	return useQuery({
		queryKey: ['commissionable-products'],
		queryFn: () => getCommissionableProducts(),
		enabled,
		staleTime: 5 * 60 * 1000, // Consider data fresh for 5 minutes
	});
};
